import { CancellationReasonEnum } from '@mopla/data-models';

// Ordered list of cancellation reasons for display
export const CANCEL_REASONS_ORDERED: CancellationReasonEnum[] = [
	CancellationReasonEnum.SUBSCRIPTION_PRICE_INCREASE,
	CancellationReasonEnum.NOT_NEEDED_ANYMORE,
	CancellationReasonEnum.CANT_AFFORD,
	CancellationReasonEnum.RECEIVING_THROUGH_EMPLOYER,
	CancellationReasonEnum.UNAWARE_OF_SUBSCRIPTION,
	CancellationReasonEnum.NOT_SATISFIED,
	CancellationReasonEnum.RECEIVING_CHEAPER,
	CancellationReasonEnum.OTHER_REASON,
];

export type TSuccessModalVariant =
	| 'cancel'
	| 'cancel_in_pause'
	| 'cancel_in_pause_out_time'
	| 'preorder_cancel_in_time'
	| 'preorder_cancel_out_time'
	| 'revoke';

export interface ICancelFormValues {
	reason: CancellationReasonEnum | null;
	otherReasonText: string;
	acceptConditions: boolean;
}

/**
 * Case types for cancellation flow:
 * - CancelInTime: User cancels within deadline (applies to ACTIVE)
 * - CancelOutTime: User cancels after deadline (applies to ACTIVE)
 * - PreorderCancelInTime: PREORDERED subscription cancelled more than 24h before subscribtion start
 * - PreorderCancelOutTime: PREORDERED subscription cancelled less than 24h before subscribtion start (takes effect next month)
 * - Revoke: User has pending cancellation and wants to revoke it
 * - PendingPause: User has upcoming pause scheduled and wants to cancel
 * - ActivePause: User is currently in pause and wants to cancel
 * - ActivePauseCancelOutTime: User is in pause and cancels after deadline
 */
export enum ECancellationCase {
	CancelInTime = 'cancel-in-time',
	CancelOutTime = 'cancel-out-time',
	PreorderCancelInTime = 'preorder-cancel-in-time',
	PreorderCancelOutTime = 'preorder-cancel-out-time',
	Revoke = 'revoke',
	PendingPause = 'pending-pause',
	ActivePause = 'active-pause',
	ActivePauseCancelOutTime = 'active-pause-cancel-out-time',
}

export interface ICancellationDates {
	validUntilDate: string;
	validUntilDateLong: string;
	invalidFromDate: string;
	todayDate: string;
	pauseStartDate: string;
	pauseEndDate: string;
	cancellationNoticeDeadlineDate: string;
	cancellationNoticeDeadlineDateLong: string;
	extendedCancellationDate: string;
	subscriptionStartDateLong: string;
}
